import { Stack, TextField, Typography } from "@mui/material";
import type { Dispatch } from "react";
import ExpandableListWithBadge from "@entrilia/shared/components/ExpandableListWithBadge";
import FieldsDiffTable from "@entrilia/shared/components/FieldsDiffTable";
import ChangesWarningAlert from "../../common/ChangesWarningAlert";
import { getBankDescription, getFieldChanges, getSelectedFunds } from "./newBankAccountReviewHelper";
import type { Action, NewBankAccountState } from "./newBankAccountState";

interface Props {
  state: NewBankAccountState;
  dispatch: Dispatch<Action>;
}

const NewBankAccountReview = ({ state, dispatch }: Props) => {
  return (
    <Stack spacing={2.5} sx={{ py: 2.5 }}>
      <ChangesWarningAlert />
      <Stack spacing={2}>
        <Stack spacing={0.5}>
          <Typography variant="h6">Bank Details</Typography>
          <Typography color="textSecondary">{getBankDescription(state)}</Typography>
        </Stack>
        <FieldsDiffTable fieldChanges={getFieldChanges(state)} newValueColumnLabel="New" />
      </Stack>
      <ExpandableListWithBadge title="Fund Assignments" items={getSelectedFunds(state)} maxVisibleItems={5} />
      <Stack spacing={2.5} sx={{ width: "100%" }}>
        <Typography variant="subtitle2">Comment</Typography>
        <TextField
          fullWidth
          multiline
          rows={3}
          spellCheck
          placeholder="Add an optional comment for the reviewer..."
          variant="outlined"
          value={state.comment}
          onChange={(e) => dispatch({ type: "update_comment", value: e.target.value })}
        />
      </Stack>
    </Stack>
  );
};

export default NewBankAccountReview;
